import { render, staticRenderFns } from "./mentStaff.vue?vue&type=template&id=c472f2fa&scoped=true"
import script from "./mentStaff.vue?vue&type=script&lang=js"
export * from "./mentStaff.vue?vue&type=script&lang=js"
import style0 from "./mentStaff.vue?vue&type=style&index=0&id=c472f2fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c472f2fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c472f2fa')) {
      api.createRecord('c472f2fa', component.options)
    } else {
      api.reload('c472f2fa', component.options)
    }
    module.hot.accept("./mentStaff.vue?vue&type=template&id=c472f2fa&scoped=true", function () {
      api.rerender('c472f2fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/assess/staff/mentStaff.vue"
export default component.exports